"use client";

import { useState } from "react";

import { Github } from "@/ui/icons";
import { Menu } from "@/ui/Menu";
import { NovelsEditor } from "@/ui/Editor";
import { Sidebar } from "@/ui/Sidebar";
import { EditorContext } from "@/context/EditorContext";
import { useSidebar } from "@/hooks/useSideBar";
import { Editor } from "@tiptap/react";
import { PanelLeft, PanelLeftClose } from "lucide-react";
import { cn } from "@/lib/utils";

export default function Page() {
  const { isOpen, close, toggle } = useSidebar();
  const [saveStatus, setSaveStatus] = useState("Saved");
  const [editor, setEditor] = useState<Editor | null>(null);

  const toggleLeftSidebar = () => {
    toggle();
  };

  return (
    <EditorContext.Provider
      value={{
        editor,
        setEditor,
        saveStatus,
        setSaveStatus,
      }}
    >
      <div className="relative flex h-full w-full">
        {editor && <Sidebar isOpen={isOpen} onClose={close} editor={editor} />}
        <div
          className={cn(
            "relative flex h-full flex-1 flex-col items-center overflow-hidden transition-all duration-300 sm:px-5 sm:py-16",
            isOpen ? "ml-80" : "",
          )}
        >
          <header className="-mt-12 flex w-full items-center justify-between gap-2">
            <div className="flex items-center gap-x-1.5">
              <button
                className="z-10 max-h-fit rounded-lg p-2 transition-colors duration-200 hover:bg-stone-100"
                onClick={toggleLeftSidebar}
              >
                {isOpen ? (
                  <PanelLeftClose className="h-5 w-5" />
                ) : (
                  <PanelLeft className="h-5 w-5" />
                )}
              </button>
            </div>
            <div className="flex items-center gap-2">
              <a
                href="https://github.com/xiaoluoboding/novels"
                target="_blank"
                className="z-10 max-h-fit rounded-lg p-2 transition-colors duration-200 hover:bg-stone-100"
              >
                <Github />
              </a>
              <Menu />
            </div>
          </header>
          <NovelsEditor />
        </div>
      </div>
    </EditorContext.Provider>
  );
}
